<div class="spinner-wrapper">
  <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
</div>
